import React from 'react'
import { AnimateOnScrolledTo } from './AnimateOnScrolledTo'

interface ParallaxSectionProps {
  image: string
  children: React.ReactNode
  overlayOpacity?: string
  height?: string
}

export function ParallaxSection({
  image,
  children,
  overlayOpacity = 'bg-black/40',
  height = 'h-[70vh]',
}: ParallaxSectionProps) {
  return (
    <section
      className={`
        relative ${height} 
         bg-center bg-fixed 
        flex items-center bg-cover bg-no-repeat
      `}
      style={{ backgroundImage: `url(${image})` }}
    >
      {/* Dark overlay */}
      <div
        className={`
          absolute inset-0 
          pointer-events-none 
          ${overlayOpacity}
        `}
      />

      {/* Text wrapper */}
      <AnimateOnScrolledTo
        triggerPosition="center"
        scrollTriggerPercentage={0.8}
        className="relative z-10 w-full h-full flex items-center justify-center"
      >
        {children}
      </AnimateOnScrolledTo>
    </section>
  )
}
